import { Component, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, share } from 'rxjs/operators';

import { AngularFireAuth } from '@angular/fire/auth';

@Component({
  selector: 'app-escritorio',
  templateUrl: './escritorio.component.html',
  styleUrls: ['./escritorio.component.css']
})
export class EscritorioComponent implements OnInit {

  nombreMarca = "AquaRisk";
  public marcaImageBarra: string =''; // '/assets/iconos/marcabarra-b.png';
  public marcaImage: string = '/assets/iconos/marca-d.png';
  hoyDia = new Date().getDate();
  hoyMes = new Date().getMonth()+1;
  hoyAno = new Date().getFullYear();

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      share()
    );

  constructor(private breakpointObserver: BreakpointObserver,
    public controlUsuario: AngularFireAuth) {}

  ngOnInit() {
  }

}
